import { render, staticRenderFns } from "./primary-search.vue?vue&type=template&id=1766d377&"
import script from "./primary-search.vue?vue&type=script&lang=js&"
export * from "./primary-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports